"use strict";

import angular from "angular";
import { User } from "../../../gateway/User/User";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { AccountingContractManager } from "../../../presentation/services/AccountingContractManager/AccountingContractManager";
import { UpdateUserBrowserStorageUsecase } from "../../../usecases";
import { SaveManyUserUsecase } from "../../../usecases/save-many-user.usecase";

angular
    .module("nucont.accounting.nps")
    .config(["$stateProvider", routeConfig]);

function npsLazyLoad(transition) {
    const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
    return import(
        /* webpackChunkName: "feature-accounting-nps" */ "./nps.entry"
    ).then(() => $ocLazyLoad.inject("nucont.accounting.nps"));
}

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.npsform", {
            url: "nps/:accountingId/:id/:score/:NPSId",
            params: {
                accountingId: {
                    value: null
                },
                id: {
                    value: null
                },
                score: {
                    value: null
                },
                NPSId: {
                    value: null
                }
            },
            lazyLoad: npsLazyLoad,
            views: {
                "main@": {
                    component: "emptyLayoutComponent"
                },
                "empty@nucont.npsform": {
                    component: "npsFormComponent"
                }
            },
            bodyClass: "nps-form"
        })
        .state("nucont.accounting.nps", {
            url: "/nps",
            lazyLoad: npsLazyLoad
        })
        .state("nucont.accounting.nps.view", {
            url: "/ver",
            views: {
                "admin@nucont.accounting": {
                    component: "npsViewComponent"
                }
            }
        })
        .state("nucont.accounting.nps.view.overview", {
            url: "/visao-geral?date",
            params: {
                date: {
                    value: "",
                    dynamic: true
                }
            },
            views: {
                "npsView@nucont.accounting.nps.view": {
                    component: "npsOverviewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "searchInput.placeholder",
                            value: "Procurar empresa..."
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.nps.view.feedbacksReports", {
            url:
                "/feedbacks-relatorios?date&startDate&endDate&&companyId&&reportId",
            params: {
                startDate: {
                    value: "",
                    dynamic: true
                },
                endDate: {
                    value: "",
                    dynamic: true
                },
                companyId: {
                    value: "",
                    dynamic: true
                }
            },
            views: {
                "npsView@nucont.accounting.nps.view": {
                    component: "feedbacksReportsViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "searchInput.placeholder",
                            value: "Procurar empresa ou usuário"
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.nps.dashboard", {
            url: "/dashboard?date",
            params: {
                date: {
                    value: null,
                    dynamic: true
                }
            },
            views: {
                "admin@nucont.accounting": {
                    component: "npsDashboardComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4"
                }
            },
            resolve: {
                setTheme: [
                    "$stateParams",
                    "$state",
                    "ThemesService",
                    "accountingData",
                    "accountingPlanEntity",
                    async (
                        $stateParams,
                        $state,
                        ThemesService,
                        accountingData,
                        accountingPlanEntity
                    ) => {
                        const user = new UserDataAdapter().user();
                        const UserDomain = new User();
                        if (!accountingData)
                            return $state.go(
                                "nucont.accounting.overview.portfolio.companies.resume",
                                {
                                    accountingId:
                                        user.profile.accountingId ||
                                        $state.params.accIdReference ||
                                        $state.params.accountingId ||
                                        $stateParams.accIdReference ||
                                        $stateParams.accountingId
                                }
                            );
                        const hasPermission = new AccountingContractManager({
                            User: UserDomain
                        }).hasPermission({
                            contract: accountingData.contract,
                            user: user,
                            feature: "dashboardThemes",
                            accountingPlanEntity: accountingPlanEntity
                        });
                        if (
                            hasPermission === "expired" &&
                            user.profile.dashboardTheme !== "default"
                        ) {
                            const saveManyUserUsecase = new SaveManyUserUsecase();
                            const userId = new UserDataAdapter().user()._id;
                            saveManyUserUsecase.execute({
                                accountingId: accountingData._id,
                                users: [
                                    { _id: userId, dashboardTheme: "default" }
                                ]
                            });
                            const updateUserBrowserStorageUsecase = new UpdateUserBrowserStorageUsecase();
                            updateUserBrowserStorageUsecase.execute({
                                dashboardTheme: "default"
                            });
                            ThemesService.setCurrentDashboardTheme("default");
                        } else {
                            ThemesService.setCurrentDashboardTheme(
                                user.profile.dashboardTheme || "default"
                            );
                        }
                    }
                ]
            }
        });
}
